import EmberTable from 'ember-table/components/ember-table/component';

import type {
  CustomEmberTableColumn,
  CustomEmberTableRow,
} from '../../../types/components/prism/table.ts';

/**
 * A wrapper around the `ember-table` component that allows us to specify our custom column type.
 */
export default class PrismTableCustomEmberTable extends EmberTable<
  CustomEmberTableRow,
  CustomEmberTableColumn
> {}
